import { useFocusableGroup, useTabsterAttributes } from '@fluentui/react-tabster';

export const useMessageAttributes = ({
  id,
  defaultFocused,
}: {
  id: string;
  defaultFocused?: boolean;
}): {
  'data-tabster': string | undefined;
  role: string;
  tabIndex: number;
  id: string;
  'aria-labelledby': string;
} => {
  // Initialize groupper
  useFocusableGroup();

  const accessibleProps = {
    role: 'article',
    tabIndex: 0,
    id,
    'aria-labelledby': `${id}`,
  };

  const tabsterProps = useTabsterAttributes({
    groupper: { tabbability: 2 /*limitedTrapFocus*/ },
    focusable: { isDefault: defaultFocused },
  });

  return { ...accessibleProps, ...tabsterProps };
};
